export default __webpack_public_path__ + "static/media/caricias.03555e72.png";